import { BoloQueueRowData } from '../../../../socket/stream-types';
import { EditBoloItem } from './edit-bolo-item';
import { ExpireBoloItem } from './expire-bolo-item';

export function BoloContextMenu({ data }: { data: BoloQueueRowData }) {
    return (
        <>
            <EditBoloItem boloId={data.id} />
            <ExpireBoloItem boloId={data.id} />
        </>
    );
}
